export enum Gender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other',
}
